import React from "react";

const Body = () => {
  return <div>exam details</div>;
};

export default Body;
